<rt-button
  variant="outline"
  rt-overlay-origin
  (click)="dropdown.open = true"
  [dropdownOpened]="dropdown.open"
  #limitSelectorDropdownTrigger="rtOverlayOrigin"
>
  <rt-icon name="sort" />
  {{ 'rtu.ui.search.per_page' | translate }}: {{ limit() }}
</rt-button>
<ng-template
  #dropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [open]="dropdown.open"
  [origin]="limitSelectorDropdownTrigger"
  (backdropClick)="dropdown.open = false"
>
  <rt-dropdown [width]="DropdownWidth.SmallXX">
    @for (option of limitOptions(); track trackByOptionValue($index, option)) {
      <rt-dropdown-item
        [highlighted]="option === limit()"
        (click)="limitChange.emit(option); dropdown.open = false"
      >
        {{ option }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
